export default  [
	{ label: 'School Name', key: 'name' },
	{ label: 'Men Team', key: 'menteam' },
	{ label: 'Women Team', key: 'womenteam' },
	{ label: 'Men JV1 Team', key: 'menjv1team' },
	{ label: 'Men JV2 Team', key: 'menjv2team' },
	{ label: 'Women JV1 Team', key: 'womenjv1team' },
	{ label: 'Women JV2 Team', key: 'womenjv2team' }
 ]


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Participants/Constants/listHeaders.js